<template>
  <div>
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="控制租户「套餐订阅」页展示哪些套餐。关闭后前台不再展示，也无法在线购买或认款开通；已开通记录不受影响。"
      style="margin-bottom:14px"
    />
    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="planName" label="套餐" width="120" />
      <el-table-column prop="planCode" label="编码" width="110" />
      <el-table-column label="价格" width="120">
        <template slot-scope="{ row }">{{ priceText(row) }}</template>
      </el-table-column>
      <el-table-column label="时长" width="90">
        <template slot-scope="{ row }">{{ durationText(row.durationDays) }}</template>
      </el-table-column>
      <el-table-column label="账号上限" width="100">
        <template slot-scope="{ row }">{{ accountText(row.maxUsers) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="说明" min-width="220" show-overflow-tooltip />
      <el-table-column label="前台展示" width="110" fixed="right">
        <template slot-scope="{ row }">
          <el-switch
            :value="row.enabled === 1"
            :disabled="savingId === row.id"
            @change="onToggle(row, $event)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { listOpsPlans, setOpsPlanEnabled } from '../../api/sys'

export default {
  name: 'OpsPlan',
  data() {
    return {
      loading: false,
      savingId: null,
      list: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    priceText(row) {
      if (row.planCode === 'PRIVATE') return '联系报价'
      if (row.priceCent == null || Number(row.priceCent) <= 0) return '免费'
      return (Number(row.priceCent) / 100).toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }) + ' 元'
    },
    durationText(days) {
      if (days == null || days === '') return '-'
      if (Number(days) === 0) return '长期'
      if (Number(days) >= 360) return '年'
      return days + ' 天'
    },
    accountText(max) {
      if (max == null) return '-'
      if (Number(max) <= 0) return '不限'
      return max + ' 个'
    },
    async load() {
      this.loading = true
      try {
        const res = await listOpsPlans()
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    async onToggle(row, on) {
      const enabled = on ? 1 : 0
      this.savingId = row.id
      try {
        await setOpsPlanEnabled(row.id, enabled)
        row.enabled = enabled
        this.$message.success(enabled === 1 ? '已上架，租户可见' : '已下架，租户不可见')
      } catch (e) {
        await this.load()
      } finally {
        this.savingId = null
      }
    }
  }
}
</script>
